// extracted by mini-css-extract-plugin
export default {"header":"New_header__h9oeY","buttonsRight":"New_buttonsRight__2lq+N","buttonUSD":"New_buttonUSD__YEhqN","pageContent":"New_pageContent__6l6hH"};